import { render } from "./ChampionshipNewsForm.vue?vue&type=template&id=4541cbb2"
import script from "./ChampionshipNewsForm.vue?vue&type=script&lang=js"
export * from "./ChampionshipNewsForm.vue?vue&type=script&lang=js"

import "./ChampionshipNewsForm.vue?vue&type=style&index=0&id=4541cbb2&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__